import { v5 as uuidv5 } from "uuid";

const QUANT_PORTAL_UUIDV5_NAMESPACE = '1dad5316-9938-4dcf-9530-42b0c64911ec';

export const get_uuid_from_string = (value: string) => uuidv5(value, QUANT_PORTAL_UUIDV5_NAMESPACE);